import { PlatformType } from "@/common/constants/shared";
import { CallTargetType } from "@/common/types";
import { TeamsCall } from "@azure/communication-calling";
import { InteractionDirection } from "./interactions";

export interface TrustedEndpoint {
	id: string;
	sipUrl: string;
	lineUrl: string;
	name: string;
	queueName: string;
	applicationId: string;
	applicationName: string;
	phoneNumber: string;
	value: string;
	queueId: string;
	objectId: string;
	acsResourceId?: string;
}

export interface AgentInformation {
	agentId: string;
	agentUpn: string;
	tenantId: string;
	azureTenantId: string;
}

export interface SelectedEndpoint {
	objectId: string;
	name: string;
	queueId: string;
	queueName: string;
	phoneNumber: string;
	applicationId: string;
}

export enum TargetSelectionSource {
	Invalid = "Invalid",
	Manual = "Manual",
	TopBarSearch = "TopBarSearch",
	ContactList = "ContactList",
	HistoryCall = "HistoryCall",
	HistoryVoicemail = "HistoryVoicemail",
	VoicemailInProgress = "VoicemailInProgress",
	CustomerHistory = "CustomerHistory",
}

export interface TargetInformation {
	target: string;
	isPstn: boolean;
	contactId: string | undefined;
	contactName: string | undefined;
	selectionSource: TargetSelectionSource | undefined;
	selectionType: CallTargetType | undefined;
	selectionInteractionHistoryId: string | undefined;
}

export interface OutboundCallRequest {
	selectedEndpoint: SelectedEndpoint;
	agent: AgentInformation;
	target: TargetInformation;
	platformType: PlatformType;
	scenarioId: string | null;
	ringingFilePath?: string;
	serverSideCall: boolean; // if call should be started server side
	skipInitCallSession: boolean; // if call session should not be created in backend (client side unify calls)
	isAgent: boolean; // if unify call should be offered in browser (for agent) or teams (for users)
}

export interface OutboundCallResponse {
	contactNotFound: boolean;
	isSelfRinging: boolean;
	contactId: string;
	contactName: string;
	isAgent: boolean;
}

export interface OngoingCall {
	name: string;
	info: string;
	call: TeamsCall;
	date: Date;
	direction: InteractionDirection;
	isCCaaSCall: boolean;
}
